export default __webpack_public_path__ + "static/media/No60Closed.0bf6d94a.jpg";